(function ($) {
	const LOGIN_COMPLETE_MESSAGE = 'w4d-login-complete';
	const LOGIN_ACK_MESSAGE = 'w4d-login-ack';

	class W4D_SocialPopupLogin {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$body = $('body');
			this.popupSelector = '[data-js-social-popup]';
			this.popup = null;
			this.popupOrigin = null;
		}

		bindEvents() {
			$(document).on('click', this.popupSelector, (e) => this.openPopup(e));
			window.addEventListener('message', (e) => this.handleMessage(e));
		}

		openPopup(e) {
			e.preventDefault();

			const url = e.currentTarget.href;
			const width = 600;
			const height = 600;
			const left = screen.width / 2 - width / 2;
			const top = screen.height / 2 - height / 2;

			// The plugin builds the start and callback URLs with home_url() (this page's origin); an
			// older plugin used site_url(), which may differ, so remember it to verify the message.
			try {
				this.popupOrigin = new URL(url, window.location.href).origin;
			} catch {
				this.popupOrigin = null;
			}

			this.popup = window.open(url, 'w4d_social_login', `width=${width},height=${height},top=${top},left=${left}`);

			// Popup blocked (Safari, blockers, in-app browsers): log in in this tab instead; the
			// callback page redirects in place when it has no opener.
			if (!this.popup) {
				window.location.href = url;
			}
		}

		handleMessage(event) {
			// Accept only the popup this page opened, on our own origin or the origin it was opened on.
			if (!this.popup || event.source !== this.popup || event.data !== LOGIN_COMPLETE_MESSAGE) {
				return;
			}

			if (event.origin !== window.location.origin && event.origin !== this.popupOrigin) {
				return;
			}

			// Tell the callback page we handle it, so it closes instead of navigating this page.
			try {
				event.source.postMessage(LOGIN_ACK_MESSAGE, event.origin);
			} catch {
				// The popup closes itself after its timeout either way.
			}

			this.popup = null;
			// Same as a successful password login without a redirect: reload in place
			// (the login page itself redirects logged-in users to My Account).
			window.location.reload();
		}

		checkLogin() {
			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: {
					action: 'w4d_check_login',
				},
				success: (response) => {
					if (response.logged_in) {
						window.location.href = '/moj-racun';
					}
				},
				error: () => {},
			});
		}
	}

	$(document).ready(() => {
		window.W4D_SocialPopupLogin = new W4D_SocialPopupLogin();
	});
})(jQuery);
